module.exports = __webpack_public_path__ + "static/media/but_link_doc.d047c316.svg";